module.exports = __webpack_public_path__ + "static/img/15.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/15.jpg
// module id = SWZ5
// module chunks = 36